import React from 'react';
import { Row } from '../row';
import { Checkbox as MCheckbox } from '@mui/material';
import { Text } from '../text';

export const Checkbox = (props) => {
  return (
    <Row onClick={props.onClick} className="cbrow">
      <MCheckbox {...(props.checkProps || {})} checked={props.checked} onChange={props.onChange} />
      {props.label && <Text>{props.label}</Text>}
    </Row>
  );
};
